import { render, staticRenderFns } from "./EstateAdministrationCostCalculatorIntro.vue?vue&type=template&id=485240a0&scoped=true"
import script from "./EstateAdministrationCostCalculatorIntro.vue?vue&type=script&lang=js"
export * from "./EstateAdministrationCostCalculatorIntro.vue?vue&type=script&lang=js"
import style0 from "./EstateAdministrationCostCalculatorIntro.vue?vue&type=style&index=0&id=485240a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485240a0",
  null
  
)

export default component.exports